<template>
    <div class="auto-loader" v-if="paginationData.page < paginationData.max_pages" id="auto_loader">
        <div class="auto-loader__body" />
    </div>
</template>
<script src="./autoLoader.js" />
<style src="./autoLoader.scss" lang="scss" scoped />
